module.exports = __webpack_public_path__ + "img/insta.a4810c10.svg";